export default __webpack_public_path__ + "static/media/psydoc1.7147e316.png";